const mediaFileList = {
  state: {
    fileList: []
  },
  actions: {

  },
  mutations: {
    SET_FILE_LIST: (state, data) => {
      state.fileList = data
    },
    ADD_FILE_TO_LIST: (state, data) => {
      state.fileList.push(data)
    },
    DEL_FILE_IN_LIST: (state, data) => {
      state.fileList = state.fileList.filter(item => item.id !== data.id)
    },
    UPDATE_FILE_LIST: (state, data) => {
      state.fileList = state.fileList.map(item => {
        if (item.id === data.id) {
          return data
        }
        return item
      })
    },
    FIND_FILE_IN_LIST: (state, data) => {
      const file = state.fileList.find(item => item.id === data.id)
      if (file) {
        return file
      }
    },
    CLEAR_FILE_LIST: (state) => {
      state.fileList = []
    }
  },
  getters: {
    fileList: state => state.fileList
  },
}

export default mediaFileList
